export default __webpack_public_path__ + "static/media/pizza_tmp.e67f27ea.jpg";